import { NgModule } from '@angular/core';
import {DisqusComponent} from "./disqus.component";

@NgModule({
  declarations: [DisqusComponent],
  exports: [DisqusComponent],
  providers: [],
  imports: []
})
export class DisqusModule {

}



// WEBPACK FOOTER //
// ./src/app/shared/comments/disqus.module.ts